class PopupNewsletter {
  constructor(el) {
    this.el = el;
    this.id = el.id;
    this.delay = parseInt(el.dataset.delay || '3', 10) * 1000;
    this.frequency = el.dataset.frequency || 'day';
    this.isSuccess = el.dataset.success === 'true';

    this.paneForm = el.querySelector('.popup-newsletter__pane--form');
    this.paneSuccess = el.querySelector('.popup-newsletter__pane--success');
    this.copyBtn = el.querySelector('[data-copy-code]');

    this._bindEvents();
    this._init();
  }

  _bindEvents() {
    this.el.addEventListener('click', (e) => {
      if (e.target === this.el.querySelector('.popup-newsletter__overlay')) this.close();
      if (e.target.closest('[data-popup-close]')) this.close();
      if (e.target.closest('[data-popup-skip]')) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.el.hidden) this.close();
    });

    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', () => this._copyCode());
    }
  }

  _init() {
    // Server confirmed the form was just successfully submitted
    if (this.isSuccess) {
      this._showSuccess();
      setTimeout(() => this.show(), 100);
      return;
    }

    // Always show immediately in the theme editor
    if (window.Shopify && window.Shopify.designMode) {
      this.show();
      return;
    }

    if (!this._shouldShow()) return;
    setTimeout(() => this.show(), this.delay);
  }

  _storageKey() {
    return `tns_popup_${this.id}`;
  }

  _shouldShow() {
    if (this.frequency === 'always') return true;

    const key = this._storageKey();

    if (this.frequency === 'session') {
      return !sessionStorage.getItem(key);
    }

    const stored = localStorage.getItem(key);
    if (!stored) return true;

    const elapsed = Date.now() - parseInt(stored, 10);
    if (this.frequency === 'day') return elapsed > 86400000;
    if (this.frequency === 'week') return elapsed > 604800000;

    return true;
  }

  _markShown() {
    const key = this._storageKey();
    if (this.frequency === 'session') {
      sessionStorage.setItem(key, '1');
    } else if (this.frequency !== 'always') {
      localStorage.setItem(key, String(Date.now()));
    }
  }

  show() {
    this.el.removeAttribute('hidden');
    this.el.getBoundingClientRect(); // force reflow for transition
    this.el.classList.add('popup-newsletter--visible');
    this._markShown();

    if (this.paneForm && !this.paneForm.hidden) {
      const firstInput = this.el.querySelector('input[type="email"]');
      if (firstInput) setTimeout(() => firstInput.focus(), 350);
    }
  }

  close() {
    this.el.classList.remove('popup-newsletter--visible');
    setTimeout(() => this.el.setAttribute('hidden', ''), 320);
  }

  _showSuccess() {
    if (this.paneForm) this.paneForm.hidden = true;
    if (this.paneSuccess) this.paneSuccess.removeAttribute('hidden');
  }

  _copyCode() {
    const codeEl = this.el.querySelector('[data-discount-code]');
    if (!codeEl) return;

    const code = codeEl.textContent.trim();

    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(() => this._flashCopy());
    } else {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      this._flashCopy();
    }
  }

  _flashCopy() {
    if (!this.copyBtn) return;
    this.copyBtn.classList.add('popup-newsletter__copy--done');
    setTimeout(() => this.copyBtn.classList.remove('popup-newsletter__copy--done'), 2000);
  }
}

const popupEl = document.querySelector('[data-popup-newsletter]');
if (popupEl) new PopupNewsletter(popupEl);
